import { render, staticRenderFns } from "./Datenschutz.vue?vue&type=template&id=45cad1a5&scoped=true"
import script from "./Datenschutz.vue?vue&type=script&lang=js"
export * from "./Datenschutz.vue?vue&type=script&lang=js"
import style0 from "./Datenschutz.vue?vue&type=style&index=0&id=45cad1a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cad1a5",
  null
  
)

export default component.exports